const PAGE_PARAM = 'page';

export function parsePageNumberFromUrlParams(
  urlParams: URLSearchParams,
): number {
  const page = urlParams.get(PAGE_PARAM);

  return +(page ?? 1);
}

export function formatPageNumberToUrlParams(
  pageNumber?: number,
  urlParams?: URLSearchParams,
): URLSearchParams {
  const newUrlParams = new URLSearchParams(urlParams);

  if (pageNumber && pageNumber > 1) {
    newUrlParams.set(PAGE_PARAM, `${pageNumber}`);
  } else {
    newUrlParams.delete(PAGE_PARAM);
  }

  return newUrlParams;
}
